import _ from "lodash";

export function isCalloutOverlay(item) {
	return !!item && `${item.shape || ""}`.toLowerCase() === "callout";
}

// Protect the complete records, including unknown/legacy fields, while allowing
// the rest of the media markup to be edited. Never filter callouts out on save.
export function canChangeCalloutOverlays(previous = [], next = [], enabled = false) {
	return enabled === true || _.isEqual(previous.filter(isCalloutOverlay), next.filter(isCalloutOverlay));
}

export function shouldUseMediaMarkupV2(preferV2, enabled, imageHotspots = []) {
	// Legacy markup has no callout renderer or read-only preservation policy.
	return (preferV2 && enabled) || (Array.isArray(imageHotspots) && imageHotspots.some(isCalloutOverlay));
}
